<template>
    <design-2021-portfolio-shared-assignments-component :education-levels-in="educationLevelsIn" :assignments-in="assignmentsIn"
                                            :organization-id-in="organizationIn.id">
    </design-2021-portfolio-shared-assignments-component>
</template>

<script>
export default {
    name: "design-2021-assignment-databank-show-component",
    props: {
        assignmentsIn: Array,
        educationLevelsIn: Array,
        organizationIn: Object,
    },
    data() {
        return {
            assignments: [],
        }
    }
}
</script>

<style scoped>

</style>
